<template>
  <div
    :id="id"
    class="properties-field"
  >
    <div class="wrap-properties">
      <!-- Configuration Title -->
      <div class="properties-field-title">
        <h4 class="title">Configuration</h4>
        <div
          class="close-properties"
          @click="!showModalFieldLibrary ? closeConfiguration() : null"
        >
          &times;
        </div>
      </div>

      <!-- Configuration Content -->
      <div class="properties-field-content properties-field-content-config">
        <!-- Title Section -->
        <div class="section-field input-field">
          <b-form
            :class="{'error-input' : $v.dataSetup.title.$error}"
            class="input-field m__b--14">
            <label> Title </label>
            <j-input
              v-model="dataSetup.title"
              :error-required="false"
              placeholder="Enter title view"
            />
          </b-form>
        </div>

        <!-- Configuration -->
        <div class="section-field input-field">
          <!-- Filter Configuration -->
          <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Filter</h4>
                <p class="configuration-section-desc">
                  Filter data according to the parameters
                </p>
              </div>

              <!-- Filter Operator -->
              <div class="filter-option">
                <div class="filter-selected">{{ dataSetup.filterOperator }}</div>
                <i
                  class="fa fa-chevron-down"
                  @click="showFilterOptions = true"
                />

                <!-- Select Filter Operator -->
                <div
                  v-if="showFilterOptions"
                  class="filter-options"
                >
                  <p>Operator</p>

                  <div class="d-flex align-items-center justify-content-around">
                    <div
                      v-for="operator in filterOperatorOptions"
                      :key="operator.id"
                      :class="{'operator-selected': operator.id === dataSetup.filterOperator }"
                      class="operator-option"
                      @click="closeFilterOptions(operator.id)"
                    >
                      {{ operator.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter by Value -->
            <h3 class="configuration-section-subtitle">By Value</h3>
            <div
              v-for="(data, index) in dataSetup.filter"
              :key="index"
              class="div-filter"
            >
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteFilter(index)"
                />
              </div>
              <b-form class="mb-2">
                <label> Column </label>
                <j-single-select
                  v-model="data.key"
                  :error-required="false"
                  :options="variableOptions"
                  :placeholder="'Select Column'"
                  value-format="object"
                  label="label"/>
              </b-form>
              <b-form>
                <label> Value </label>
                <j-input
                  v-model="data.value"
                  :error-required="false"
                  :placeholder="'Input Filter Value'"/>
              </b-form>
            </div>

            <div
              class="btn-add-config"
              @click="addFilter">
              + Add Parameter
            </div>

            <div class="separator" />

            <!-- Filter by Function -->
            <h3 class="configuration-section-subtitle">By Function</h3>
            <div
              v-for="(data, index) in dataSetup.filter_function"
              :key="index"
              class="div-filter"
            >
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteFilterFunction(index)"
                />
              </div>
              <b-form class="mb-2">
                <label> Column </label>
                <j-single-select
                  v-model="data.key"
                  :error-required="false"
                  :options="variableOptions"
                  :placeholder="'Select Column'"
                  value-format="object"
                  label="label"/>
              </b-form>
              <b-form>
                <label> Function </label>
                <j-single-select
                  v-model="data.value"
                  :options="listFunction"
                  :placeholder="'Select Function'"
                  :error-required="false"
                  label="name" />
              </b-form>
            </div>

            <div
              class="btn-add-config"
              @click="addFilterFunction">
              + Add Parameter
            </div>
          </div>

          <!-- Default Rows Page -->
          <div class="configuration-section">
            <h4 class="configuration-section-title">Rows Per Page</h4>
            <p class="configuration-section-desc">
              Option list for total rows per page  as a default, and the
              maximum limit that can be applied per page is 10,000 records.
            </p>
            <div
              v-for="(option, index) in dataSetup.rows_page_option"
              :key="index"
            >
              <div
                :class="{'error-input':
                  dataSetup.rows_page_option.length > 0 &&
                $v.dataSetup.rows_page_option.$each[index].$error}"
                class="div-row-page-option"
              >
                <input
                  :id="option"
                  v-model="dataSetup.rows_page_default"
                  :value="option"
                  :disabled="option === ''"
                  type="radio"
                >
                <input
                  v-model="dataSetup.rows_page_option[index]"
                  type="number"
                  placeholder="Option"
                >
                <i
                  class="fa fa-trash cursor-pointer"
                  @click="deleteRowPageOption(index)"/>
              </div>
            </div>
            <div
              class="btn-add-config"
              @click="addRowPageOption">
              + Add Option
            </div>
          </div>

          <!-- Freeze Header Table -->
          <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Freeze Header Table</h4>
                <p class="configuration-section-desc">
                  Prevents the row headers of a table from scrolling out
                  of view while examining extensive data
                </p>
              </div>
              <j-toggle
                v-model="dataSetup.freeze_header_table"
                class="toggle"/>
            </div>
          </div>
        </div>

        <!-- Search Options Section -->
        <div class="section-field input-field">
          <h4 class="title-section">Search Options</h4>

          <!-- Fields Search Options Configuration -->
          <div class="configuration-section">
            <h4 class="configuration-section-title">Fields</h4>
            <p class="configuration-section-desc">
              The field used can be adjusted as needed
            </p>

            <draggable
              v-model="dataSetup.search_options_list"
              :options="{
                animation:300,
                handle:'.icon-drag'
              }"
              class="d-flex flex-wrap"
            >
              <div
                v-for="(data, index) in dataSetup.search_options_list"
                :key="index"
                :class="{'selected': index === selectedIndexField}"
                class="field-list"
              >
                <p class="column-name">{{ data.name }}</p>

                <field-preview
                  :column="data"
                />

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click="editField(index)"
                    >
                      <i class="fa fa-pencil-square-o" />
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click="deleteField(index)"
                    >
                      <i class="fa fa-trash" />
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <div
              class="btn-add-config"
              @click="openModalFieldLibrary('export')"
            >
              + Add Field
            </div>
          </div>
        </div>
      </div>

      <!-- Configuration Button -->
      <div
        :class="{ 'justify-content-end': !isHaveConfiguration }"
        class="properties-field-button"
      >
        <button
          v-if="isHaveConfiguration"
          :disabled="showModalFieldLibrary"
          class="button-border"
          @click="deleteView"
        >
          <i class="fa fa-trash" /> Delete View
        </button>

        <div class="d-flex align-items-center">
          <button
            :disabled="showModalFieldLibrary"
            class="button-border mr-2"
            @click="closeConfiguration"
          >
            Close
          </button>

          <button
            :disabled="showModalFieldLibrary"
            class="button-blue"
            @click="submitForm"
          >
            Apply
          </button>
        </div>
      </div>
    </div>

    <!-- Properties -->
    <properties-field
      v-if="selectedField"
      :ref="idProperties"
      :id="[idProperties]"
      :field-detail="selectedField"
      :variable-options="variables"
      :field-ui-key="dataSetup.search_options_list"
      :is-detail-view="true"
      :is-group="true"
      :is-new-field="isNewFieldGroup"
      @delete-field="deleteField"
      @close-properties="togglePropertiesField(false)"
      @submit-mode="submitField"
    />
  </div>
</template>

<script>
/* eslint-disable max-len */
import { required, maxValue } from 'vuelidate/lib/validators';
import draggable from 'vuedraggable';
import PropertiesField from '@/views/experience-manager-v2/partials/PropertiesField';
import FieldPreview from '@/views/experience-manager-v2/partials/FieldPreview';
// Mixins
import jMixAutoScroll from '@/mixins/jMixAutoScroll';
import jMixConfiguration from '@/mixins/form-ui-v2/jMixConfiguration';

export default {
  name: 'ExportViewConfiguration',

  components: {
    draggable,
    PropertiesField,
    FieldPreview,
  },

  mixins: [jMixAutoScroll, jMixConfiguration],

  props: {
    id: {
      type: String,
      default: '',
    },
    dataConfig: {
      type: Object,
      default: () => {},
    },
    listFunction: {
      type: Array,
      default: () => [],
    },
    variables: {
      type: Array,
      default: () => [],
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
    isHaveConfiguration: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dataSetup: {
        title: null,
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        search_options_list: [],
        rows_page_default: 10,
        rows_page_option: [10, 20, 50, 100],
        freeze_header_table: false,
      },
    };
  },

  watch: {
    // eslint-disable-next-line
    'dataSetup.title': function (val){
      setTimeout(() => {
        this.dataSetup.title = val.replace(' ', '_');
      }, 1);
    },
  },

  created() {
    if (this.dataConfig) {
      const detail = this._.cloneDeep(this.dataConfig);

      this.dataSetup.title = detail.title || null;
      this.dataSetup.filter = detail.filter;
      this.dataSetup.filter_function = detail.filter_function;
      this.dataSetup.filterOperator = detail.filterOperator || 'and';
      this.dataSetup.search_options_list = detail.search_options_list || [];
      this.dataSetup.rows_page_default = detail.rows_page_default;
      this.dataSetup.rows_page_option = detail.rows_page_option;
      this.dataSetup.freeze_header_table = detail.freeze_header_table;
    }
  },

  methods: {
    // Open/close stacked properties
    togglePropertiesField(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById(this.idProperties);
          const elementParent = document.getElementById(this.id);
          if (element) {
            elementParent.classList.add('show-properties-group');
            element.classList.add('show-properties-field');
          }
        }, 200);
      } else {
        const element = document.getElementById(this.idProperties);
        const elementParent = document.getElementById(this.id);
        if (element) {
          element.classList.remove('show-properties-field');
          elementParent.classList.remove('show-properties-group');
        }

        setTimeout(() => {
          this.selectedField = null;
          this.selectedIndexField = null;
          this.isNewFieldGroup = false;
          this.setIsSearch(false);
        }, 200);
      }
    },

    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$emit('submit', this.dataSetup);
        this.closeConfiguration();
      } else {
        this.scrollToErrorField('error-input');
      }
    },

    deleteView() {
      this.$emit('delete-view');
    },

    closeConfiguration() {
      this.$emit('close-configuration');

      setTimeout(() => {
        this.dataSetup = {
          title: null,
          filter: [
            {
              key: null,
              value: null,
            },
          ],
          filter_function: [
            {
              key: null,
              value: null,
            },
          ],
          filterOperator: null,
          search_options_list: [],
        };

        this.$v.dataSetup.$reset();
      }, 400);
    },

    addRowPageOption() {
      if (Array.isArray(this.dataSetup.rows_page_option)) {
        this.dataSetup.rows_page_option.push('');
      } else {
        this.dataSetup.rows_page_option = [];
        this.dataSetup.rows_page_option.push('');
      }
    },

    deleteRowPageOption(index) {
      this.dataSetup.rows_page_option.splice(index, 1);
    },
  },

  validations() {
    return {
      dataSetup: {
        title: { required },
        filter: { },
        filter_function: { },
        filterOperator: { },
        search_options_list: { },
        rows_page_option: {
          $each: {
            maxValue: maxValue(10000),
          },
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/configuration/ExportViewConfiguration.vue